import type { View } from '../hooks/useViewRouter';
import styles from './ViewSwitcher.module.css';

interface ViewSwitcherProps {
  activeView: View;
  onSwitch: (view: View) => void;
}

export function ViewSwitcher({ activeView, onSwitch }: ViewSwitcherProps) {
  return (
    <div className={styles.container}>
      <button
        className={`${styles.tab} ${activeView === 'chat' ? styles.tabActive : ''}`}
        onClick={() => onSwitch('chat')}
      >
        Chat
      </button>
      <button
        className={`${styles.tab} ${activeView === 'board' ? styles.tabActive : ''}`}
        onClick={() => onSwitch('board')}
      >
        Board
      </button>
    </div>
  );
}
